import React from "react";
import {
  CheckCircle2,
  ArrowRight,
  Send,
  CalendarClock,
  AlertTriangle,
  Users,
  RotateCcw,
  ShieldCheck,
  Wallet,
} from "lucide-react";
import "./VoucherOverviewTab.css";


const basicInfo = [
  { label: "Voucher Name", value: "VIP Exclusive Voucher" },
  { label: "Voucher Code", value: "VIP500" },
  { label: "Type", value: "Fixed Amount" },
];

const status = "Active";

const basicInfoRow2 = [
  { label: "Created By", value: "Ahmed Hassan" },
  { label: "Created On", value: "Mar 10, 2025" },
  { label: "Last Update", value: "May 18, 2025 - 02:30 pm" },
];

const valueBalance = [
  { label: "Initial Value", value: "500,000 EGP" },
  { label: "Redeemed Value", value: "168,000 EGP" },
  { label: "Remaining Balance", value: "332,000 EGP" },
  { label: "Average Redemption Value", value: "131 EGP" },
];

const valueBalanceRow2 = [
  { label: "Total Redemptions", value: "1,284" },
  { label: "Outstanding Liability", value: "332,000 EGP" },
];

const progress = {
  redeemedPct: 33.6,
  redeemedValue: "168,000 EGP",
  remainingPct: 66.4,
  remainingValue: "332,000 EGP",
};

const assignment = [
  { label: "Assignment Type", value: "Segment-Based" },
  { label: "Assigned To", value: "VIP Customers" },
  { label: "Distribution Channel", value: "Mobile App + Admin Assignment" },
];

const assignmentRow2 = [
  { label: "Used By", value: "3,200 users" },
  { label: "Assigned By", value: "Mona Salah" },
  { label: "Assignment Date", value: "Mar 10, 2025" },
];

const validity = [
  { label: "Start Date", value: "Mar 10, 2025" },
  { label: "End Date", value: "May 31, 2025" },
  { label: "Days Remaining", value: "13 days left" },
];

const autoExpiry = "Enabled";

const expiryBehavior = {
  label: "Expiry Behavior",
  value: "Unused balance expires automatically",
};

const rules = [
  { label: "Stack Behavior", value: "Non-Stackable" },
  { label: "Partial Redemption", value: "Allowed", pill: true },
  { label: "Restore on Cancel", value: "Enabled", pill: true },
  { label: "Fraud Risk", value: "Low" },
];

const rulesRow2 = [
  { label: "Applicable Channels", value: "Mobile App , Call Center" },
  { label: "Usage Limit", value: "One per eligible user" },
  { label: "Excluded Items", value: "Taxes, Doorstep Fee" },
];

const funding = [
  { label: "Funding Source", value: "ESTBN" },
  { label: "Provider Share", value: "0%" },
  { label: "ESTBN Share", value: "100%" },
];

const fundingRow2 = [
  { label: "Total Committed Value", value: "500,000 EGP" },
  { label: "Total Redeemed Cost", value: "168,000 EGP" },
  { label: "Remaining Commitment", value: "332,000 EGP" },
];

const liabilitySnapshot = [
  { icon: Wallet, label: "Outstanding Balance", value: "332,000 EGP" },
  {
    icon: AlertTriangle,
    label: "High Liability Vouchers",
    value: "24",
    iconColor: "#FEB91E",
  },
  {
    icon: RotateCcw,
    label: "Highest Remaining Balance",
    value: "420,000 EGP",
    iconColor: "#3FBEAC",
  },
];

const quickInsights = [
  { icon: CalendarClock, iconColor: "#FEB91E", text: "Near Expiry in 13 days" },
  { icon: Users, iconColor: "#7E1BAD", text: "High usage among VIP customers" },
  { icon: RotateCcw, iconColor: "#535353", text: "Restore on cancel enabled" },
  { icon: ShieldCheck, iconColor: "#3FBEAC", text: "Low fraud expousure" },
];

const recentActivity = [
  {
    title: "Voucher details updated",
    date: "May 18, 2025 - 02:30 pm",
    user: "Ahmed Hassan",
  },
  {
    title: "Assignment expanded to more users",
    date: "May 16, 2025 - 11:45 am",
    user: "Mona Salah",
  },
  {
    title: "Redemption spike detected",
    date: "May 14, 2025 - 09:20 am",
    user: "System",
  },
  {
    title: "Rules & eligibility updated",
    date: "May 12, 2025 - 04:15 pm",
    user: "Ahmed Hassan",
  },
  {
    title: "Voucher exported",
    date: "May 11, 2025 - 03:10 pm",
    user: "Mona Salah",
  },
];

function StepBadge({ n }) {
  return <span className="vt-step-badge">{n}</span>;
}

function FieldGrid({ items }) {
  return (
    <div className="vt-field-grid">
      {items.map((f) => (
        <div className="vt-field-item" key={f.label}>
          <span className="vt-field-label">{f.label}</span>
          {f.pill ? (
            <span className="vt-enabled-pill">
              <CheckCircle2 size={12} /> {f.value}
            </span>
          ) : (
            <span className="vt-field-value">{f.value}</span>
          )}
        </div>
      ))}
    </div>
  );
}

// ================== MAIN COMPONENT ==================
export default function VoucherOverviewTab() {
  return (
    <div className="vt-grid">
      {/* ---------- MAIN COLUMN ---------- */}
      <div className="vt-main">
        <div className="vt-panel">
          {/* 1. Basic Information */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={1} />
              <h3 className="vt-card-title">Basic Information</h3>
            </div>

            <FieldGrid items={basicInfo} />
            <div className="vt-field-grid vt-field-grid-row2">
             
              {basicInfoRow2.map((f) => (
                <div className="vt-field-item" key={f.label}>
                  <span className="vt-field-label">{f.label}</span>
                  <span className="vt-field-value">{f.value}</span>
                </div>
              ))}
               <div className="vt-field-item">
                <span className="vt-field-label">Status</span>
                <span className="vt-active-pill">
                  <span className="vt-dot" /> {status}
                </span>
              </div>
            </div>
          </div>
          <div className="vt-panel-divider" />
          {/* 2. Value & Balance */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={2} />
              <h3 className="vt-card-title">Value & Balance</h3>
            </div>
            <FieldGrid items={valueBalance} />
            <div className="vt-field-grid vt-field-grid-row2">
              {valueBalanceRow2.map((f) => (
                <div className="vt-field-item" key={f.label}>
                  <span className="vt-field-label">{f.label}</span>
                  <span className="vt-field-value">{f.value}</span>
                </div>
              ))}
            </div>

            <div className="vt-progress-track">
              <div
                className="vt-progress-fill"
                style={{ width: `${progress.redeemedPct}%` }}
              />
            </div>
            <div className="vt-progress-labels">
              <span>
                <span className="vt-dot vt-dot-teal" /> Redeemed{" "}
                {progress.redeemedPct}% ({progress.redeemedValue})
              </span>
              <span>
                <span className="vt-dot vt-dot-gray" /> Remaining{" "}
                {progress.remainingPct}% ({progress.remainingValue})
              </span>
            </div>
          </div>
          <div className="vt-panel-divider" />
          {/* 3. Assignment & Recipient */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={3} />
              <h3 className="vt-card-title">Assignment & Recipient</h3>
            </div>
            <FieldGrid items={assignment} />
            <div className="vt-field-grid vt-field-grid-row2">
              {assignmentRow2.map((f) => (
                <div className="vt-field-item" key={f.label}>
                  <span className="vt-field-label">{f.label}</span>
                  <span className="vt-field-value">{f.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="vt-panel-divider" />
          {/* 4. Validity & Expiry */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={4} />
              <h3 className="vt-card-title">Validity & Expiry</h3>
            </div>
            <FieldGrid items={validity} />
            <div className="vt-field-grid vt-field-grid-row2">
              <div className="vt-field-item">
                <span className="vt-field-label">Auto Expiry</span>
                <span className="vt-enabled-pill">
                  <CheckCircle2 size={12} /> {autoExpiry}
                </span>
              </div>
              <div className="vt-field-item">
                <span className="vt-field-label">{expiryBehavior.label}</span>
                <span className="vt-field-value">{expiryBehavior.value}</span>
              </div>
            </div>
          </div>
          <div className="vt-panel-divider" />
          {/* 5. Rules & Safeguards */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={5} />
              <h3 className="vt-card-title">Rules & Safeguards</h3>
            </div>
            <FieldGrid items={rules} />
            <div className="vt-field-grid vt-field-grid-row2">
              {rulesRow2.map((f) => (
                <div className="vt-field-item" key={f.label}>
                  <span className="vt-field-label">{f.label}</span>
                  <span className="vt-field-value">{f.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="vt-panel-divider" />
          {/* 6. Funding & Liability */}
          <div className="vt-panel-section">
            <div className="vt-card-header">
              <StepBadge n={6} />
              <h3 className="vt-card-title">Funding & Liability</h3>
            </div>
            <FieldGrid items={funding} />
            <div className="vt-field-grid vt-field-grid-row2">
              {fundingRow2.map((f) => (
                <div className="vt-field-item" key={f.label}>
                  <span className="vt-field-label">{f.label}</span>
                  <span className="vt-field-value">{f.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* ---------- SIDEBAR ---------- */}
      <div className="vt-sidebar">
        {/* Liability Snapshot */}
        <div className="vt-card">
          <div className="vt-card-header-row">
            <h3 className="vt-card-title">Liability Snapshot</h3>
            <a className="vt-link">
              View Liability Report <ArrowRight size={14} />
            </a>
          </div>
          <div className="vt-list">
            {liabilitySnapshot.map((s) => {
              const Icon = s.icon;
              return (
                <div className="vt-list-item" key={s.label}>
                  <span
                    className="vt-list-icon"
                    style={{ color: s.iconColor || "#111827" }}
                  >
                    <Icon size={16} />
                  </span>
                  <span className="vt-list-label">{s.label}</span>
                  <span className="vt-list-value">{s.value}</span>
                </div>
              );
            })}
          </div>
        </div>
        {/* Quick Insights */}
        <div className="vt-card">
          <div className="vt-card-header-row">
            <h3 className="vt-card-title">Quick Insights</h3>
            <a className="vt-link" href="#">
              View all <ArrowRight size={14} />
            </a>
          </div>
          <div className="vt-insights-list">
            {quickInsights.map((ins, i) => {
              const Icon = ins.icon;
              return (
                <div className="vt-insight-item" key={i}>
                  <span
                    className="vt-insight-icon"
                    style={{ color: ins.iconColor }}
                  >
                    <Icon size={16} />
                  </span>
                  <span className="vt-insight-text">{ins.text}</span>
                </div>
              );
            })}
          </div>
        </div>
        {/* Recent Activity */}
        <div className="vt-card">
          <div className="vt-card-header-row">
            <h3 className="vt-card-title">Recent Activity</h3>
            <a className="vt-link" href="#">
              View all <ArrowRight size={14} />
            </a>
          </div>
          <div className="vt-timeline">
            {recentActivity.map((a, i) => (
              <div className="vt-timeline-item" key={i}>
                <div className="vt-timeline-marker-col">
                  <span
                    className={`vt-timeline-dot ${i === 0 ? "vt-timeline-dot-active" : ""}`}
                  />
                  {i < recentActivity.length - 1 && (
                    <span className="vt-timeline-line" />
                  )}
                </div>
                <div className="vt-timeline-content">
                  <div className="vt-timeline-title-row">
                    <span className="vt-timeline-title">{a.title}</span>
                    <span className="vt-timeline-user">{a.user}</span>
                  </div>
                  <span className="vt-timeline-date">{a.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Near Expiry Actions */}
        <div className="vt-card">
          <div className="vt-card-header-row">
            <h3 className="vt-card-title">Near Expiry Actions</h3>
            <a className="vt-link" href="#">
              View expiry rules <ArrowRight size={14} />
            </a>
          </div>

          <div className="vt-expiry-block">
            <span className="vt-expiry-icon">
              <CalendarClock size={18} />
            </span>
            <div className="vt-expiry-text">
              <span className="vt-expiry-title">13 days remaining</span>
              <span className="vt-expiry-sub">Expires on May 31, 2025</span>
            </div>
          </div>

          <p className="vt-expiry-desc">
            This voucher is approaching its expiry date. Take action if needed.
          </p>

          <div className="vt-expiry-actions">
            <button className="vt-btn-primary">
              <Send size={14} /> Send Reminder
            </button>
            <button className="vt-btn-outline">
              <CalendarClock size={14} /> Extend Validity
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
